import {block, unblock} from './block-ui';
import {alert} from './alerts';

let smsSent = false;

export function sendCode(phone, type) {
    block();

    $.ajax({
        type: 'POST',
        url: '/send/confirm_code/',
        data: {phone: phone, type: type},
        async: false,
        success: function (response) {
            unblock();

            if (!response) {
                return;
            }

            if (response.status === 'success') {
                smsSent = true;
            } else {
                // Произошла ошибка при отправке кода
                alert(trans('user.confirm_code_send_error'));
                smsSent = false;
            }
        },
        dataType: 'json',
    });
}

let codeConfirmed = 0;

export function confirm(phone, type, cod) {
    block();

    $.ajax({
        type: 'POST',
        url: '/send/check_confirm_code/',
        data: {phone: phone, type: type, cod: cod},
        success: function (response) {
            unblock();

            if (!response) {
                return;
            }

            codeConfirmed = response.status;

            if (response.status === 'wrong') {
                // Код подтверждения введен не верно, у Вас осталась 1 попытка
                alert(trans('user.confirm_code_wrong'));
            } else if (response.status === 'second_wrong') {
                // Код подтверждения дважды введен не верно
                alert(trans('user.confirm_code_second_wrong'));
            } else if (response.status === 'error') {
                // Произошла ошибка при проверке кода
                alert(trans('user.confirm_code_verify_wrong'));
            }
        },
        dataType: 'json',
        async: false,
    });
}

export function isSent() {
    return smsSent;
}

export function isConfirmed() {
    return codeConfirmed === 'success';
}
